import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { isAdminAuthenticated } from "@/integrations/php/client";
import { LeadProvider } from "@/context/LeadContext";
import { PartnerProvider } from "@/context/PartnerContext";
import { AssignmentProvider } from "@/context/AssignmentContext";
import AdminSidebar from "../sidebar/AdminSidebar";
import AdminHeader from "../header/AdminHeader";

const AdminLayout: React.FC = () => {
  const isMobile = useIsMobile();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    let active = true;
    isAdminAuthenticated()
      .then((authenticated) => active && setIsAuthenticated(authenticated))
      .catch((error) => {
        console.error("Authentication check error:", error);
        if (active) setIsAuthenticated(false);
      });
    return () => { active = false; };
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
        <div className="flex max-w-sm flex-col items-center text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-sky-700 ring-1 ring-slate-200 shadow-sm">
            <Loader2 className="h-6 w-6 animate-spin" />
          </div>
          <p className="mt-5 text-base font-semibold text-slate-900">Επαλήθευση πρόσβασης</p>
          <p className="mt-1 text-sm text-slate-500">Φορτώνουμε το ασφαλές περιβάλλον διαχείρισης.</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return (
    <LeadProvider>
      <PartnerProvider>
        <AssignmentProvider>
          <div className="flex min-h-screen bg-slate-50 text-slate-950">
            {!isMobile && <AdminSidebar />}
            <div className="flex min-h-screen min-w-0 flex-1 flex-col">
              <AdminHeader />
              <main className="min-w-0 flex-1">
                <div className="mx-auto w-full max-w-[1600px] px-3 py-5 sm:px-6 sm:py-7 lg:px-8 lg:py-8">
                  <Outlet />
                </div>
              </main>
            </div>
          </div>
        </AssignmentProvider>
      </PartnerProvider>
    </LeadProvider>
  );
};

export default AdminLayout;
